import initialState from "./store";
import actions from "./actions";
import reducer from "./reducer";
import { useCallback, useReducer } from "react";
import { ContextProviderProps } from "../../@types/contexts/context.types";
import DependentsContext from "./dependentContext";
import { Member } from "../../@types/member.types";

const DependentsContextProvider = ({ children }: ContextProviderProps): JSX.Element => {
	const [state, dispatch] = useReducer(reducer, initialState);
	const value = {
		dependents: state.dependents,
		setDependents: useCallback(
			(dependents: Member[]) => dispatch({ type: actions.SET_DEPENDENTS, payload: dependents }),
			[]
		)
	};

	return <DependentsContext.Provider value={value}>{children}</DependentsContext.Provider>;
};

export default DependentsContextProvider;
